import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const WorkChromeContext = createContext(null);

/**
 * Позволяет странице (colab) зарегистрировать панель инструментов в шапке Layout.
 */
export function WorkChromeProvider({ children }) {
  const [toolbarProps, setToolbarPropsState] = useState(null);

  const setToolbarProps = useCallback((next) => {
    setToolbarPropsState(next);
  }, []);

  const clearToolbarProps = useCallback(() => {
    setToolbarPropsState(null);
  }, []);

  const value = useMemo(
    () => ({ toolbarProps, setToolbarProps, clearToolbarProps }),
    [toolbarProps, setToolbarProps, clearToolbarProps],
  );

  return <WorkChromeContext.Provider value={value}>{children}</WorkChromeContext.Provider>;
}

export function useWorkChrome() {
  const ctx = useContext(WorkChromeContext);
  if (!ctx) {
    throw new Error('useWorkChrome must be used within WorkChromeProvider');
  }
  return ctx;
}
